<template>
  <div>
    <v-form
      ref="form"
      :class="$vuetify.breakpoint.smAndDown ? 'form-mobile' : 'form-desktop'"
      v-model="valid"
      :lazy-validation="lazy"
    >
      <h1 style="text-align: center">Get in touch</h1>

      <v-text-field
        class="text-box-items"
        v-model="name"
        :counter="32"
        :rules="nameRules"
        label="Name"
        full-width
      ></v-text-field>

      <v-text-field
        class="text-box-items"
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        full-width
      ></v-text-field>

      <v-textarea
        class="message"
        v-model="message"
        :rules="messageRules"
        name="input-7-1"
        label="Talk to us! We'll answer."
        value=""
        hint="Hint text"
      ></v-textarea>

      <v-btn
      v-if="$vuetify.breakpoint.mdAndUp"
      :class="['desktop-send-button', 'mr-4']"
      :disabled="!valid"
      color="white"
      :x-large="!$vuetify.breakpoint.smAndDown"
      :width="theWidth"
      @click="
        submit();
        validate();
      "
    >
      Send
    </v-btn>
    </v-form>
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      :class="['mobile-send-button', 'mr-4']"
      :disabled="!valid"
      color="white"
      :large="!$vuetify.breakpoint.smAndDown"
      :width="theWidth"
      @click="
        submit();
        validate();
      "
    >
      Send
    </v-btn>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    name: '',
    nameRules: [
      (v) => !!v || 'Name is required',
      (v) => (v && v.length <= 32) || 'Name must be less than 32 characters'
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    message: '',
    messageRules: [
      (v) => !!v || 'Message is required',
      (v) =>
        (v && v.length <= 500) || 'Message must be less than 500 characters'
    ],
    lazy: false
  }),
  mounted () {
    this.validate()
  },
  computed: {
    theWidth () {
      return this.$vuetify.breakpoint.smAndDown ? '90vw' : ''
    }
  },
  methods: {
    submit () {
      // console.log('Name:', this.name)
      // console.log('Email:', this.email)
      // console.log('Message: ', this.message)
      this.$firebase
        .firestore()
        .collection('contactSubmissions')
        .add({
          name: this.name,
          email: this.email,
          message: this.message
        })
        .then((docRef) => {
          console.log('Document written with ID: ', docRef.id)
          this.$emit('emitComplete', true)
        })
        .catch(function (error) {
          console.error('Error adding document: ', error)
        })
    },
    validate () {
      this.$refs.form.validate()
    }
  }
}
</script>

<style lang="scss">
.form-mobile {
  display: block;
  width: 1000px;
  max-width: 90vw;
  background-color: white;
  color: black;
  padding: 20px 0 40px 0;
  border-radius: 25px;
}
.mobile-send-button {
  border-radius: 25px;
  margin-top: 30px;
  padding: 0 0;
}
.form-desktop {
  display: block;
  width: clamp(40vw, 1000px, 60vw);
  max-width: 90vw;
  background-color: white;
  color: black;
  padding: 2vw 0 2vw 0;
  border-radius: 25px;
  overflow: hidden;
  .desktop-send-button {
    float: right;
    margin: 3vw 6vw;
    border-radius: 25px;
    bottom: 1vw;
  }
}
.text-box-items {
  padding: 30px 6vw;
}

.message {
  padding: 0 6vw;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
